
<up-app-container>
  <lib-external-header></lib-external-header>

  <lib-shared-snack-bar></lib-shared-snack-bar>
  <lib-shared-loader></lib-shared-loader>

  <div class="content">
    <router-outlet></router-outlet>
  </div>
</up-app-container>
